import React from 'react';
import { Box, VStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import TestimonialCard from './TestimonialCard';

const MotionBox = motion(Box);

const TestimonialColumn = ({ testimonials, duration = 22, display, ...rest }) => {
  return (
    <Box
      flex="1"
      overflow="hidden"
      display={display}
      sx={{
        '&:hover [data-marquee-track]': {
          animationPlayState: 'paused',
        },
      }}
      {...rest}
    >
      <MotionBox
        as={VStack}
        data-marquee-track
        spacing={6}
        animate={{ translateY: ['0%', '-50%'] }}
        transition={{
          duration,
          repeat: Infinity,
          ease: 'linear',
          repeatType: 'loop',
        }}
      >
        {testimonials.map((testimonial, index) => (
          <Box key={`first-${index}`} width="full">
            <TestimonialCard
              content={testimonial.content}
              name={testimonial.name}
              role={testimonial.role}
            />
          </Box>
        ))}
        {testimonials.map((testimonial, index) => (
          <Box key={`second-${index}`} width="full">
            <TestimonialCard
              content={testimonial.content}
              name={testimonial.name}
              role={testimonial.role}
            />
          </Box>
        ))}
      </MotionBox>
    </Box>
  );
};

export default TestimonialColumn;
